import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/bluesky";

export const Route = createFileRoute(path)({
	component: BlueskyScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to Bluesky",
			description:
				"Schedule Bluesky posts with an AI agent. Cross-post from X and Threads, queue threads, and publish on time. Cancel anytime.",
		}),
});

function BlueskyScheduler() {
	return (
		<PlatformSchedulerPage
			platform="bluesky"
			platformLabel="Bluesky"
			hero={{
				title: "Connect your AI agent to Bluesky",
				description:
					"Most schedulers ignore Bluesky. AgentReacher posts to Bluesky natively, with the same agent workflow as every other platform.",
			}}
		/>
	);
}
